module.exports = __webpack_public_path__ + "img/IMG-20190904-WA0014.0b268b18.jpg";